import { render, staticRenderFns } from "./RectangleViz.vue?vue&type=template&id=47c98971&scoped=true"
import script from "./RectangleViz.vue?vue&type=script&lang=js"
export * from "./RectangleViz.vue?vue&type=script&lang=js"
import style0 from "./RectangleViz.vue?vue&type=style&index=0&id=47c98971&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c98971",
  null
  
)

export default component.exports